import {
    toNumber
} from 'lodash';

// custom parse value function
export default function parseValue(input) {
    // handle dates
    if (typeof input === 'undefined') return null
    if (input.indexOf('/') > -1) return input
    // handle numbers as string
    let number = toNumber(input.replace(',', ''))
    if (isNaN(number)) return input // return input if string
    return number
}